import { useFeeQuery } from '@puzzlehq/frontend-utils';
import { useBalance } from '@puzzlehq/sdk';
import { useEffect, useState } from 'react';

export const useFeeValid = (functionId: string) => {
  const { balances } = useBalance();
  const creditsBalance = balances?.find(
    (balance) =>
      balance.programId === 'credits.aleo' && balance.symbol === 'ALEO'
  );

  const feeQuery = useFeeQuery({
    programId: import.meta.env.VITE_SQUASH_PROGRAM_ID!,
    functionId: functionId,
    network: import.meta.env.VITE_NETWORK!,
  });
  const [feeValid, setFeeValid] = useState<boolean | undefined>();
  useEffect(() => {
    if (feeQuery.data) {
      if (feeQuery.data?.covered) {
        setFeeValid(true);
        return;
      }
      if (!!creditsBalance && !!feeQuery.data.fee) {
        const fee = feeQuery.data.fee.fee.total;
        const hasSufficientPublicBalance = creditsBalance.values.public >= fee;
        const hasSufficientPrivateBalance =
          creditsBalance.values.private >= fee;
        if (hasSufficientPublicBalance || hasSufficientPrivateBalance) {
          setFeeValid(true);
        } else {
          setFeeValid(false);
        }
      }
    }
  }, [creditsBalance, feeQuery.data]);

  return feeValid;
};
